module.exports = {
  siteTitle: 'Yash Raj Thakore | Software Engineer',
  siteDescription:
    'Yash Thakore is a software engineer based in Orlando, Florida who specializes in building and designing web applications, websites, and anything else I think of.',
  siteKeywords:
    'Yash Thakore, Yash, Thakore, ythakore05, software engineer, front-end engineer, web developer, javascript',
  siteUrl: 'https://yashthakore.com',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-127188467-2',
  googleVerification: 'zWJzGMVk8J4FpXsLNpt7CB17SPaa2_ti9YfdGwnGr00',
  name: 'Yash Raj Thakore',
  location: 'Orlando, FL',
  email: 'yashthakore50@yahoo.com',
  github: 'https://github.com/YashThakore',
  twitterHandle: '@thakore_yash',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/YashThakore',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/yashrajthakore',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/yash.thakore',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/thakore_yash',
    },
  ],
  lastUpdated: '30-June-2024',

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Working On',
      url: '/#workingon',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Gallery',
      url: 'https://gallery.yashthakore.com',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
